import {  Component } from '@angular/core';
import { IonContent } from '@ionic/angular';
import {GlobalVars} from '../providers/globalVars';
//import {Storage} from '@ionic/storage';

// import * as $ from 'jquery';



@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage {

  constructor(public gv: GlobalVars) {
   
    /*this.gv.getmenulist().then(rst => {
      if(rst)
        this.tabinfo = rst;
    });*/
  }

 
  totop(){
    if(this.gv.selectedcontent)
    <IonContent>this.gv.selectedcontent.scrollToTop(100);
  }

  ngOnInit() {
    /*this.gv.getLocLan().then(loclan=>{
      this.loclan = loclan;
      this.getdata();
    })*/
    /*
    if (this.gv.getLoc() && this.gv.getLan()) {
      this.loclan = this.gv.getLoc() + '_' + this.gv.getLan();
      this.getdata();
    } else {
      let loc, lan;
      if (!this.gv.getLoc()) {
            loc = 'cairns';
          this.gv.setLoc(loc);
          this.loclan = loc + '_' + this.gv.getLan();
          this.getdata();
        //})
      }
    }*/

  }
ionViewWillEnter() {
  // if (this.activatedRoute.snapshot['_routerState'].url)
  //   this.selectedtab = this.activatedRoute.snapshot['_routerState'].url.replace('/tabs/', '');
}
 

  
}